// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HvHOg","questions":"styles_questions__1B0N-","footer":"styles_footer__ozvKr"};